export default "__VITE_ASSET__D8duS04G__"